<p-dialog
    #dialog
    [id]="id() + '-modal'"
    [(visible)]="visible"
    [modal]="true"
    [resizable]="false"
    [closeOnEscape]="true"
    [draggable]="draggable()"
    [closable]="closable()"
    [dismissableMask]="dismissableMask()"
    [class]="'custom-modal ' + severity()"
    [style]="{ width: modalSize() }"
    (onHide)="onHide.emit()">
    <ng-template #header>
        <div class="header-content">
            @if (severityIcon().length) {
                <i class="fa-regular" [ngClass]="severityIcon()"></i>
            }
            <p>{{ title() | translate }}</p>
        </div>
    </ng-template>

    <ng-content></ng-content>

    <ng-template #footer>
        @if (includeFooter()) {
            <p-divider></p-divider>
            <div class="footer-actions">
                @if (includeCancelButton()) {
                    <btn-cancel
                        [id]="'modal-cancel'"
                        [label]="cancelButtonLabel() | translate"
                        [severity]="cancelButtonSeverity()"
                        [disabled]="actionsLoading()"
                        (onClick)="dialog.close($event); onCancel.emit()"></btn-cancel>
                }
                @if (includeConfirmButton()) {
                    <btn
                        [id]="'modal-save'"
                        [label]="confirmButtonLabel()"
                        [severity]="confirmButtonSeverity()"
                        [loading]="actionsLoading()"
                        [disabled]="confirmButtonDisabled()"
                        (onClick)="onConfirm.emit()"></btn>
                }
            </div>
        }
    </ng-template>
</p-dialog>
